import Axios from 'axios'
import React, { useState } from 'react'
import { CardActions, CreateButton, ExportButton } from 'react-admin'
import { auth0, getApiUrl } from '../auth/client'

const CategoryListActions = ({ basePath, permissions, total }) => {
  const [loading, setLoading] = useState(false)

  const handleExport = async () => {
    try {
      console.log('Export categories started')

      const apiUrl = await getApiUrl()

      if (!apiUrl) {
        console.log('Export categories error url is not set')
        return
      }

      setLoading(true)

      const response = await Axios.post(
        `${apiUrl}/api/categories/export`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${await auth0.getTokenSilently()}`,
          },
          responseType: 'blob',
        },
      )

      const downloadUrl = URL.createObjectURL(response.data)
      const a = document.createElement('a')
      a.href = downloadUrl
      a.download = 'export-categories.csv'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(downloadUrl)

      console.log('Export categories successful')
    } catch (error) {
      console.log('Export categories unknown error', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <CardActions>
      {permissions?.includes('create:categories') && <CreateButton basePath={basePath} />}
      {permissions?.includes('read:categories') && (
        <ExportButton
          label={loading ? 'Exporting...' : 'Export'}
          disabled={total === 0 || loading}
          onClick={handleExport}
        />
      )}
    </CardActions>
  )
}

export default CategoryListActions
